import React from 'react';
import ContactPersonsBlockContact from './ContactPersonsBlockContact';
import Link from 'components/Link';
import PropTypes from 'prop-types';

import './ContactPersonsBlock.scss';

const ContactPersonsBlock = ({ heading, contacts, seeAllLink }) => {
  return (
    <div className="contact-persons-block">
      <div className="contact-persons-block__container">
        <div className="contact-persons-block__header">
          {heading && (
            <h2 className="contact-persons-block__heading">{heading}</h2>
          )}
          {seeAllLink && (
            <Link
              {...seeAllLink}
              className="contact-persons-block__see-all-link"
            />
          )}
        </div>
        {contacts && contacts.length > 0 && (
          <div className="contact-persons-block__content">
            {contacts.map((contact, index) => (
              <ContactPersonsBlockContact key={index} {...contact} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

ContactPersonsBlock.propTypes = {
  heading: PropTypes.string,
  contacts: PropTypes.arrayOf(
    PropTypes.exact(ContactPersonsBlockContact.propTypes)
  ).isRequired,
  seeAllLink: PropTypes.exact(Link.propTypes),
};

export default ContactPersonsBlock;
